<div class="cleanup-modal">
  <h2 class="cleanup-title">Character Cleanup</h2>
  <p class="cleanup-info">
    {{ upgradePlan?.name | uppercase }} subscription allows
    <strong>{{ upgradePlan?.features?.max_active_characters === -1 ? 'Unlimited' : upgradePlan?.features?.max_active_characters }}</strong>
    characters. Items in <span class="cleanup-danger-word">red</span> will be deleted.
  </p>

  @if (characterList.length > 0) {
    <div class="cleanup-table-wrap">
      <table class="cleanup-table">
        <thead>
          <tr>
            <th>Character Name</th>
            <th>Lvl</th>
            <th>Race</th>
            <th>Class</th>
            <th>Map</th>
            <th>Last Played</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (c of characterList; track c) {
            <tr>
              <td [class.cleanup-danger]="isCharacterAutoDeleted(c)">{{ c.first_name || 'Unnamed' }}</td>
              <td [class.cleanup-danger]="isCharacterAutoDeleted(c)">{{ c.primary_class_level || 0 }}</td>
              <td [class.cleanup-danger]="isCharacterAutoDeleted(c)">{{ c.race }}</td>
              <td [class.cleanup-danger]="isCharacterAutoDeleted(c)">{{ c.primary_class }}</td>
              <td [class.cleanup-danger]="isCharacterAutoDeleted(c)">{{ c.map_name || 'None' }}</td>
              <td [class.cleanup-danger]="isCharacterAutoDeleted(c)">{{ (c.updated_at | date:'MMM d, yyyy') || 'Never' }}</td>
              <td>
                @if (!isCharacterAutoDeleted(c)) {
                  <div class="cleanup-row-actions">
                    <button type="button" class="cleanup-icon-btn" title="Retire Character" (click)="retireSingleCharacter(c)" [disabled]="isDeleting">
                      <i class="fa fa-bed"></i>
                    </button>
                    <button type="button" class="cleanup-icon-btn" title="Delete Character" (click)="deleteSingleCharacter(c)" [disabled]="isDeleting">
                      <img src="assets/icons/icon-delete.svg" alt="Delete">
                    </button>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (manualCharactersToDelete > 0) {
    <p class="cleanup-summary cleanup-summary--danger">
      Please delete or retire <span class="cleanup-summary-count">{{ manualCharactersToDelete }}</span> character(s)
    </p>
  }
  @if (manualCharactersToDelete === 0) {
    <p class="cleanup-summary cleanup-summary--success">No characters require deletion</p>
  }

  <div class="cleanup-actions">
    @if (!downgradeResponse?.cleanup_required) {
      <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
    }
    <button type="button" class="btn btn-theme" (click)="next()" [disabled]="manualCharactersToDelete > 0 || isDeleting">Proceed</button>
    <button type="button" class="btn btn-theme" (click)="subscribe()">Subscribe</button>
  </div>
</div>
